import { compose } from 'ramda';
import { defaultProps } from 'recompose';

import SettingsPageContent from '@/components/PageContent';

export default compose(defaultProps({ sm: 11 }))(SettingsPageContent);
